import NextImage, { ImageLoader } from 'next/image';
import { AppDownloadModal } from '../../AppDownloadModal/AppDownloadModal';
import { Heading } from '../../Heading/Heading';
import { Text } from '../../Text/Text';
import { AppStoreButtons } from '../../Clickables/Buttons/AppStoreButtons/AppStoreButtons';
import { QRCode } from '../../QRCode/QRCode';
import arrowBlack from '../assets/arrow-black.svg';
import { NextImageWrapper } from '../../NextImage/NextImageWrapper';
import { FishCatchesIcon } from '../../Icons/FishCatchesIcon';

interface IProps {
  isAppDownloadModalOpen: boolean;
  setIsAppDownloadModalOpen: (isOpen: boolean) => void;
  sourceId?: string;
  imageUrl: string;
  imgProxyLoader: ImageLoader;
  isNewCatch: boolean;
}

export const FishingReportDownloadModal = ({
  isAppDownloadModalOpen,
  setIsAppDownloadModalOpen,
  sourceId,
  imageUrl,
  imgProxyLoader,
  isNewCatch,
}: IProps) => {
  return (
    <AppDownloadModal
      appDownloadSource={'FishingReportCard'}
      appDownloadSourceId={sourceId}
      isModalOpen={isAppDownloadModalOpen}
      onCloseModal={() => setIsAppDownloadModalOpen(false)}
      closeButtonVariant="textNone"
      width="440px"
    >
      <div className="flex flex-col gap-6 px-6 pt-10 pb-6">
        <div className="flex items-center justify-center">
          <div className="relative size-full w-56 md:w-64">
            {isNewCatch && (
              <div
                style={{
                  clipPath:
                    'polygon(100% 100%,0 100%,999px calc(100% - 999px),calc(100% - 999px) calc(100% - 999px))',
                  transform: 'translate(calc((1 - cos(45deg))*100%), -100%) rotate(45deg)',
                  transformOrigin: '0% 100%',
                  paddingInline: '1lh',
                }}
                className="z-mid bg-clownfish-shade absolute top-0 right-0 w-[60px] p-[2px] text-center text-[8px] leading-[12px] font-bold text-white sm:w-[68px] sm:p-[4px] sm:text-[10px] md:w-[86px] md:text-[12px] md:leading-[16px]"
              >
                NEW
              </div>
            )}
            <NextImageWrapper
              wrapperClassName="size-full pb-[100%]"
              customPlaceholderIcon={<FishCatchesIcon size={100} title="fish catches icon" />}
              imageClassName="aspect-square size-full object-cover"
              alt="recently logged catch"
              fill
              src={imageUrl}
              loader={imgProxyLoader}
              sizes="(min-width: 1680px) 385px,(min-width: 600px) 25vw, 50vw"
            />
          </div>
        </div>
        <div className="flex flex-col items-center justify-center gap-2">
          <Heading variant="sm" className="m-0 text-center font-semibold">
            Want the full story behind this catch?
          </Heading>
          <Text variant="sm" className="m-0 text-center">
            See where it was caught, what gear was used—plus likes, comments, and more. Open it in
            the Fishbrain app.
          </Text>
        </div>
        <div className="flex w-full flex-col items-center justify-center gap-4 sm:flex-row sm:justify-end sm:p-4">
          <div className="flex items-center justify-center md:hidden">
            <AppStoreButtons
              orientation="vertical"
              context="downloadModal"
              source={'FishingReportCard'}
              sourceId={sourceId}
            />
          </div>
          <div className="relative hidden pb-2 md:flex">
            <Text className={`text-trench m-0 -rotate-12 whitespace-pre-line`} variant="sm">
              {`Scan the QR code 
                            to download the app!`}
            </Text>
            <NextImage
              alt="Arrow pointing to QR code"
              src={arrowBlack}
              className="absolute right-0 bottom-0 translate-y-full"
              unoptimized
            />
          </div>

          <QRCode
            size={140}
            imageSize={35}
            className="hidden sm:flex sm:justify-end sm:p-4"
            source={'FishingReportCard'}
            showOnMobileDevice
          />
        </div>
      </div>
    </AppDownloadModal>
  );
};
